import styled from 'styled-components';
import { device, shadows } from '../../../utils/styled-component-mixins';

const CardSwiperWrapperStyled = styled.div`
  .btn-wrapper {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 100;

    @media ${device.desktop} {
      display: block;
    }
  }

  .container-padding-md {
    ${(props) =>
      props.backgroundImage
        ? `background: url('${props.backgroundImage}') center/cover no-repeat;`
        : `background-color: var(--grey);`}

    ${(props) => (props.minHeight ? `min-height: ${props.minHeight}` : '82.5rem')}
    padding-left: 0;
    padding-right: 0;
    position: relative;

    &:before {
      background-color: var(--white);
      clip-path: polygon(280% 0, 0 35%, 0 -1%);

      content: '';
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }

    &:after {
      background-color: var(--white);
      clip-path: polygon(0 80%, 100% 65%, 100% 100%, 0% 101%);

      content: '';
      height: 100%;
      position: absolute;
      right: 0;
      top: 0;
      width: 100%;
    }

    @media ${device.desktop} {
      ${(props) => props.backgroundImage && `background-image: url('${props.backgroundImage}');`}
      background-position: center;
      background-size: cover;
      display: block;

      padding-left: 0;
      padding-right: 0;

      z-index: 0;

      &:after {
        clip-path: polygon(0 96%, 100% 55%, 100% 101%, 0% 101%);

        z-index: -1;
      }

      &:before {
        clip-path: polygon(100% 0, 0 30%, 0 -1%);

        clip-path: polygon(100% 0, 0 45%, 0 -1%);

        z-index: -1;
      }

      & > div {
        position: relative;

        .btn-wrapper {
          bottom: 2.5rem;
          position: absolute;
          right: 11rem;
        }
      }
    }
  }

  .swiper-slide {
    ${shadows.cardShadow};
    background-color: var(--white);
    height: auto;
  }

  .swiper-button-next,
  .swiper-button-prev {
    display: none;

    @media ${device.desktop} {
      background-color: var(--grey);
      border-radius: 50%;
      display: block;
      height: 5.3rem;
      width: 5.3rem;
      opacity: 0;
      transition: all 0.3s linear;
    }

    &:after {
      color: var(--charcoal-2);
      font-size: 2.5rem;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .swiper-pagination {
    max-width: 36rem;
    left: 50%;
    transform: translateX(-50%);
  }

  .swiper {
    &:hover {
      .swiper-button-next:not(.swiper-button-disabled),
      .swiper-button-prev:not(.swiper-button-disabled) {
        opacity: 1;
      }

      .swiper-button-disabled {
        opacity: 0.35;
      }
    }

    .swiper-slide {
      height: auto;

      @media ${device.desktop} {
        max-width: 23%;
      }
    }

    .swiper-button-next,
    .swiper-button-prev {
      display: none;

      @media ${device.desktop} {
        background-color: var(--grey);
        border-radius: 50%;
        display: block;
        height: 5.3rem;
        width: 5.3rem;
        opacity: 0;
        transition: all 0.3s linear;
      }

      &:after {
        color: var(--charcoal-2);
        font-size: 2.5rem;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .swiper-button-prev {
      left: 0.55rem;
    }

    .swiper-button-next {
      right: 0.55rem;
    }
  }
  .text-wrapper {
    max-height: 80%;
  }
`;

export default CardSwiperWrapperStyled;
